// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';

// ui
import { SectionHeader } from '../../../ui/SectionHeader/SectionHeader';

// utils
import { formatCurrency } from '../../../../utils/currency';

// props
export interface PaymentProgressProps {
	currency: string;
	milestonesCompleted: number;
	progressPct: number;
	totalCommitted: number;
	totalPaid: number;
	totalPaymentMilestones: number;
}

export const PaymentProgress = ({
	currency,
	milestonesCompleted,
	progressPct,
	totalCommitted,
	totalPaid,
	totalPaymentMilestones,
}: PaymentProgressProps) => {
	const { t } = useTranslation();
	return (
		<Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
			<SectionHeader IconCircleProps={{ type: 'payment' }} title={t('paymentProgress')} />
			<Box sx={{ p: { xs: 2, sm: 3 } }}>
				<LinearProgress
					value={progressPct}
					variant="determinate"
					sx={{ height: 10, borderRadius: 5 }}
				/>
				<Stack direction="row" justifyContent="space-between" sx={{ mt: 1 }}>
					<Typography variant="body2">
						{t('paidOf', {
							paid: formatCurrency({ currency, value: totalPaid }),
							total: formatCurrency({ currency, value: totalCommitted }),
						})}
					</Typography>
					<Typography variant="body2">
						{t('milestonesCompleted', {
							completed: milestonesCompleted,
							total: totalPaymentMilestones,
						})}
					</Typography>
				</Stack>
			</Box>
		</Paper>
	);
};
